const NATIVE_PLUGIN_CLIENTS = [
  { id: 'claude-desktop', label: 'Claude Desktop / Cowork', platform: 'claude', icon: 'claude-desktop', docs: 'https://claude.com/docs/plugins/overview' },
  { id: 'chatgpt', label: 'ChatGPT / Dot', platform: 'chatgpt', icon: 'chatgpt', docs: 'https://developers.openai.com/plugins/deploy/connect-chatgpt' },
];
module.exports = { NATIVE_PLUGIN_CLIENTS };
